export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8102.fe96de95.jpg";